<div class="image-stacking">
  <div class="card_new_class" *ngFor="let image of img; let i = index" [ngClass]="{ 'active-card': isCardActive[i] }" #cardElem>
    <div fxLayoutAlign="center center" class="icon-container1">
      <span fxLayoutAlign="space-around stretch" [style.height]="item.height" [ngStyle.lt-md]="{'height': item.heightMob}" style="margin-bottom: 10px;">
        <img [src]="bannerServerPath + image.img"
             (click)="image.navigation == 0 ? goToCategories(image.catId) : link(image.navigatedUrl)"
             [alt]="image.altImage || 'images'" class="icon1">
      </span>
    </div>
  </div>
</div>
